import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";
import {getPasswordRegex, getPhoneRuleObj} from "@/plugins/vee-validate";

export default class UserModel extends BaseModel {
  uuid = null;
  first_name = null;
  last_name = null;
  password = null;
  email = null;
  branch_uuid = null;
  branches = [];
  branch_uuids = [];
  is_blocked = false;
  permissions = [];
  phone = '';
  title = '';
  department = '';
  role_id = null;
  address_1 = null;
  address_2 = null;
  city = null;
  county = null;
  state = null;
  zip_code = null;
  country_code = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});

    if (this.uuid) {
      this.rules['password'] = getPasswordRegex(false);
    }
    if (this.branches && this.branches.length > 0) {
      this.branch_uuids = this.branches.map(b => b.uuid)
    }
  }

  rules = {
    email: 'required',
    first_name: 'required',
    last_name: 'required',
    password:  getPasswordRegex(true),
    phone: getPhoneRuleObj(),
  };

  attributeLabels = {
    uuid: i18n.t('UUID'),
    first_name: i18n.t('First Name'),
    last_name: i18n.t('Last Name'),
    email: i18n.t('Email'),
    password: i18n.t('Password'),
    branch_uuid: i18n.t('Branch'),
    is_blocked: i18n.t('Blocked'),
    phone: i18n.t('Phone'),
    role_id: i18n.t('Role'),
    title: i18n.t('Title'),
    department: i18n.t('Department'),
    address_1: i18n.t('Address 1'),
    address_2: i18n.t('Address 2'),
    city: i18n.t('City'),
    state: i18n.t('State'),
    county: i18n.t('County'),
    zip_code: i18n.t('Zip/Postcode'),
    country_code: i18n.t('Country'),
  };
}
